import React, { useEffect } from "react"

function ErrorPage() {
  useEffect(() => {
    document.body.classList.remove("bg-chift")
  }, [])

  return (
    <>
      <br />
      <br />
      <h2 className="text-center">404! Ouch.. Something Went Wrong!</h2>
    </>
  )
}

export default ErrorPage
